var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { addAccountsToGroupBulkActionType } from '../../../../../../../backend/features/accounts/shared';
import { showGroupDetailsDialog } from '../../../../../../../ui/features/groups/components/GroupsPanel/components/GroupDetailsDialog';
import { getFilterForBulkAction } from '../../../../../../../utils';
import { handleErrorDialog } from '@juvare/common-web-ui/DialogHelper';
import { launchBulkAction } from '@juvare/platform-sdk-react/ui/features/bulk-actions';
export function handleAddToNewGroup({ t, accountIds, appliedStorageFilters, groupStorageClient, onClose, totalFilteredAccounts = 0, }) {
    showGroupDetailsDialog({
        initialData: {
            filterBased: false,
            visibility: 'private',
            criteria: { filters: [] },
        },
        fullWidth: true,
        maxWidth: 'sm',
        title: t('panels.accounts.newGroupAccount', { count: (accountIds === null || accountIds === void 0 ? void 0 : accountIds.length) || totalFilteredAccounts }),
        onSubmit: (data) => __awaiter(this, void 0, void 0, function* () {
            try {
                const { id } = yield groupStorageClient.post({ action: 'create', data: data });
                launchBulkAction({
                    type: addAccountsToGroupBulkActionType,
                    title: t('panels.groups.addingAccountsToGroup'),
                    params: {
                        groupId: id,
                        filter: getFilterForBulkAction(accountIds, appliedStorageFilters),
                    },
                    onClose,
                });
            }
            catch (error) {
                handleErrorDialog(error);
            }
        }),
    });
}
